import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';
import { StripeDiscount } from '@/modules/billing/models/stripe/StripeDiscount';

export class StripeDiscountAmount extends BaseModel {
  public discount: Relationship<StripeDiscount>;

  public amount: number;

  constructor(model: Partial<StripeDiscountAmount> = {}) {
    super(model);

    this.discount = StripeDiscount.mapModel(model.discount);
    this.amount = model.amount as number;
  }
}
